exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".product-status{display:-ms-flexbox;display:flex}.product-status .label{color:#aaa;margin-right:10px}.product-status .status .dot-icon-red{-ms-flex:0 0 auto;flex:0 0 auto;margin-bottom:2px;margin-left:0;margin-right:5px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/postcss-loader!./~/sass-loader!./src/product/shared/components/product-status-info.scss
// module id = 5153
// module chunks = 0